/**
 * Centralized Split (Harness FME) feature flag names.
 * Single source of truth for flag names across the application.
 *
 * ⚠️ An empty registry is a normal state — flags are short-lived, the Split
 * wiring is permanent. Do not delete the plumbing listed in
 * `packages/service/SPLIT_SETUP.md`. This registry is the on/off switch: while
 * empty, `SplitProvider` mounts no SDK; adding an entry boots it.
 *
 * Only for flags scoped to SupportFrontend. A decision needed by other Copilot
 * surfaces belongs in the monolith Split project, or possibly calculated and
 * exposed on `/api/v4/support-eligibility/`.
 */

export const SPLIT_FLAGS: Record<string, string> = {
  // e.g. MY_FEATURE: "sf_my_feature",
} as const;

// Type for feature flag names
export type SplitFeatureFlagName =
  (typeof SPLIT_FLAGS)[keyof typeof SPLIT_FLAGS];

// Helper to get all feature flag names as an array
export const ALL_FEATURE_FLAGS: string[] = Object.values(SPLIT_FLAGS);
